const B = '/api/v1/chat';
export const chatApi = (client) => ({
    listConversations: () => client.get(`${B}/conversations`).then((r) => r.data),
    createConversation: (body) => client.post(`${B}/conversations`, body).then((r) => r.data),
    getMessages: (convId, params) => client.get(`${B}/conversations/${convId}/messages`, { params }).then((r) => r.data),
    sendMessage: (convId, body) => client.post(`${B}/conversations/${convId}/messages`, body).then((r) => r.data),
    viewFile: (convId, msgId) => client.get(`${B}/conversations/${convId}/messages/${msgId}/view`, { responseType: 'blob' }),
    uploadFile: (convId, file, caption) => {
        const form = new FormData();
        form.append('file', file);
        const params = caption ? `?caption=${encodeURIComponent(caption)}` : '';
        return client.post(`${B}/conversations/${convId}/upload${params}`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }).then((r) => r.data);
    },
    editMessage: (convId, msgId, body) => client.patch(`${B}/conversations/${convId}/messages/${msgId}`, body).then((r) => r.data),
    deleteMessage: (convId, msgId) => client.delete(`${B}/conversations/${convId}/messages/${msgId}`).then((r) => r.data),
    addReaction: (convId, msgId, body) => client.post(`${B}/conversations/${convId}/messages/${msgId}/reactions`, body).then((r) => r.data),
    removeReaction: (convId, msgId, emoji) => client.delete(`${B}/conversations/${convId}/messages/${msgId}/reactions/${encodeURIComponent(emoji)}`).then((r) => r.data),
    pinMessage: (convId, msgId) => client.post(`${B}/conversations/${convId}/messages/${msgId}/pin`).then((r) => r.data),
    unpinMessage: (convId, msgId) => client.delete(`${B}/conversations/${convId}/messages/${msgId}/pin`).then((r) => r.data),
    markRead: (convId) => client.post(`${B}/conversations/${convId}/read`).then((r) => r.data),
    sendTyping: (convId) => client.post(`${B}/conversations/${convId}/typing`).then((r) => r.data),
    getTyping: (convId) => client.get(`${B}/conversations/${convId}/typing`).then((r) => r.data),
    clearMessages: (convId) => client.delete(`${B}/conversations/${convId}/messages`).then((r) => r.data),
    deleteConversation: (convId) => client.delete(`${B}/conversations/${convId}`).then((r) => r.data),
    searchMessages: (convId, q) => client.get(`${B}/conversations/${convId}/search`, { params: { q } }).then((r) => r.data),
    /** Powers the chat composer's `@user` / `#entity` autocomplete. */
    searchMentions: (q, types) => client.get(`${B}/mentions/search`, {
        params: { q, types: types?.join(',') },
    }).then((r) => r.data),
});
//# sourceMappingURL=chat.js.map